import { RouteConfig } from 'vue-router';

const PatientList = () => import(/* webpackChunkName: "Hdr" */  './views/patient-list/patient-list.vue');
const PatientDetail = () => import(/* webpackChunkName: "Hdr" */  './views/patient-detail/patient-detail.vue');
const AnalysisReport = () => import(/* webpackChunkName: "Hdr" */  './views/analysis-report/analysis-report.vue');
const DataExport = () => import(/* webpackChunkName: "Hdr" */  './views/data-export/data-export.vue');


const routers: RouteConfig[] = [
    {
        path: 'patient-list',
        component: PatientList
    },
    {
        path: "patient-detail",
        component: PatientDetail
    },
    {
        path: "analysis-report",
        component: AnalysisReport
    },
    {
        path: "data-export",
        component: DataExport
    }
];

export default routers;
